/* ===========================================================================
   Completes the set checklist from the filter index.

   WHAT WAS WRONG
     The snippet reads coll.products under `paginate by 250`, which is the most
     Liquid will give it. On a 1,168 product collection that is a fifth of the
     shelf, and the headline stated a completeness percentage from it as fact.

     Worse, it assumed the collection was ONE set. It settles a set size by
     taking the largest printed denominator it sees and counts every card in
     the collection against that. Measured on Mega Evolution, the collection
     actually holds six sets:

       /217 Ascended Heroes 376   /132 Mega Evolution Base 210
       /86  Chaos Rising    129   /94  Phantasmal Flames   121
       /84  Pitch Black     108   /88  Perfect Order       102

     So it reported "139 of the 217 cards in this set (64%)" while Ascended
     Heroes alone was 205 of 217, and five other sets were folded into the same
     number. Reading further into the collection without splitting the sets
     would have made that more confidently wrong, not less.

   WHERE THE NUMBERS COME FROM
     The index holds every product with no ceiling, but it carries no titles,
     so the card number cannot come from there the way the snippet takes it
     from the title. It does not need to: the handle ends in the same pair.

       pikachu-ascended-heroes-055-217          ->  55 / 217
       mega-venusaur-ex-mega-evolution-base-003-132 -> 3 / 132

     1,050 of the 1,168 handles carry it. The 118 that do not are sealed
     products, which is exactly what the title parser skips too. The
     denominator identifies the set with 98 to 100% purity against the index's
     own set_name facet, so it is what the cards are grouped by, and set_name
     supplies the label.

   WHY THIS IS AN ENHANCEMENT AND NOT THE SOURCE
     The server rendered list is what assistant crawlers read, and they do not
     run scripts. Nothing here is required for the page to be correct: it
     replaces a narrow, honestly captioned count with a complete one. If any
     fetch fails the page keeps exactly what Liquid rendered.
   =========================================================================== */

(function () {
  'use strict';

  var root = document.getElementById('card-list');
  if (!root) return;

  var base = root.getAttribute('data-index-base') || '';
  var handle = root.getAttribute('data-handle') || '';
  if (!base || !handle) return;

  /* asset_url appends its own cache busting query and a base URL cannot be
     trimmed back past it, so every index file is addressed by swapping the
     filename inside the Pokemon shard's URL. */
  function url(file) { return base.replace('ll-index-pokemon.json', file); }

  /* One request per file per page, shared by the filter engine, the filter UI
     and the set checklist (whichever loads first defines it). They used to
     fetch and parse the same 1 MB shard and members list separately, and a
     phone paid for the parse twice. Keyed by path: the three build their URLs
     with different query strings for the same file. Read only: nobody may
     mutate what it returns. A failure is forgotten so a retry can refetch. */
  var llJson = window.__llJson || (window.__llJson = (function () {
    var cache = {};
    return function (url) {
      var key = String(url).split('?')[0];
      if (!cache[key]) {
        cache[key] = fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
          if (!r.ok) throw new Error(key.split('/').pop() + ' ' + r.status);
          return r.json();
        });
        cache[key].catch(function () { delete cache[key]; });
      }
      return cache[key];
    };
  }()));

  function getJson(u) {
    return llJson(u).catch(function () { return null; });
  }

  /* TWO NUMBERING SCHEMES, AND THE DASH THAT TELLS THEM APART.

     Pokemon, Magic and Lorcana print a card number over the set size, and the
     handle keeps it: gardevoir-chilling-reign-reverse-holo-061-198. One Piece
     and Digimon print a SET CODE and a number instead, with no size at all:
     monkey-d-luffy-leader-op16-022, mamemon-double-diamond-sr-bt6-064.

     The old pattern had no leading dash, so it happily read op16-022 as card
     16 of a set of 22 and shattered One Piece into dozens of two card sets
     that the minimum-size filter then threw away. That is why those
     collections showed no checklist at all rather than a wrong one. Requiring
     the dash separates them: a set size is always preceded by one, a set code
     never is. Measured across the index: 11,601 slash against 0 code on
     Pokemon, 0 slash against 143 code on One Piece, 0 against 233 on Digimon. */
  var NUM  = /-(\d{1,3})-(\d{1,3})$/;
  var CODE = /-([a-z][a-z0-9]{0,4})-(\d{1,3})$/;

  function parseCard(h) {
    var m = NUM.exec(h);
    if (m) return { num: parseInt(m[1], 10), den: parseInt(m[2], 10) };
    m = CODE.exec(h);
    if (m) return { num: parseInt(m[2], 10), den: 0, code: m[1] };
    return null;
  }
  var IN_STOCK = 2, F_FLAGS = 5, F_SET = 3, F_PRICE = 6;

  /* A handful of cards carry a denominator that belongs to no set on the
     shelf: a /6 promo, a /162 stray. One card is not a checklist, and drawing
     a six cell grid beside a 217 cell one implies a set we do not stock. */
  var MIN_SET = 8;

  /* Which printing a handle describes. Order matters: a reverse holo says both
     "reverse" and "holo", and it is the reverse that a collector is tracking. */
  var P_REVERSE = /(^|-)reverse(-|$)/;
  var P_FOIL    = /(^|-)foil(-|$)/;
  var P_HOLO    = /(^|-)holo(-|$)/;
  var P_PROMO   = /(^|-)promo(-|$)/;

  function printingOf(h) {
    if (P_REVERSE.test(h)) return 'reverse';
    if (P_FOIL.test(h)) return 'foil';
    if (P_HOLO.test(h)) return 'holo';
    if (P_PROMO.test(h)) return 'promo';
    return 'normal';
  }

  function titleCase(slug) {
    var out = [];
    slug.split('-').forEach(function (w, i) {
      /* A slug cannot hold an apostrophe, so "the world's strongest warriors"
         arrives as the-world-s-strongest-warriors and read back as "The World
         S Strongest Warriors". A lone s after a word is that apostrophe. */
      if (i > 0 && (w === 's' || w === 't') && out.length) {
        out[out.length - 1] += "'" + w;
        return;
      }
      if (w === 'ex' || w === 'gx' || w === 'tcg') { out.push(w.toUpperCase()); return; }
      out.push(w.charAt(0).toUpperCase() + w.slice(1));
    });
    return out.join(' ');
  }

  /* ---- selecting rows and buying them in one go ---------------------------
     Same endpoint and same payload shape the collection card's own Add button
     uses, so a bulk add and a single add are indistinguishable to the cart.
     items[] rather than a request per card: one round trip, and Shopify either
     takes the whole selection or none of it, so the cart can never end up
     holding half of what was ticked. */

  (function bulk() {
    var bar = root.querySelector('[data-llcl-bulk]');
    var count = root.querySelector('[data-llcl-count]');
    var btn = root.querySelector('[data-llcl-add]');
    if (!bar || !btn) return;

    function picked() {
      return [].slice.call(root.querySelectorAll('.llcl__pick:checked'));
    }
    function sync() {
      var boxes = picked();
      var n = boxes.length;
      if (count) count.textContent = String(n);

      /* What the selection costs, so a shopper filling a set knows before the
         cart does. Read off the row rather than fetched, because the price is
         already rendered there. */
      var pence = 0, unpriced = 0;
      boxes.forEach(function (b) {
        var row = b.closest('.llcl__row');
        var txt = row && row.querySelector('.llcl__price');
        var v = txt && txt.textContent.replace(/[^0-9.]/g, '');
        if (v) pence += Math.round(parseFloat(v) * 100); else unpriced++;
      });
      var totalEl = root.querySelector('[data-llcl-total]');
      if (totalEl) {
        /* One Price TBC row used to blank the whole total, which is the least
           useful moment to say nothing: a set selection is dozens of rows and
           one of them being unpriced should not hide what the other forty
           cost. The known total stands, with a plus to say it is a floor. */
        totalEl.textContent = n ? (MONEY(pence) + (unpriced ? '+' : '')) : '';
        totalEl.title = unpriced ? (unpriced + ' selected card(s) have no price yet') : '';
      }

      bar.hidden = n === 0;
      btn.disabled = false;
      btn.textContent = 'Add to cart';
    }

    root.addEventListener('change', function (e) {
      if (e.target && e.target.classList.contains('llcl__pick')) sync();
    });

    btn.addEventListener('click', function () {
      var boxes = picked();
      if (!boxes.length) return;
      btn.disabled = true;
      btn.textContent = 'Adding';

      /* A row Liquid rendered already knows its variant. One built from the
         index knows only its handle, so those are looked up now, in parallel,
         and only for what was actually ticked. */
      var resolve = boxes.map(function (b) {
        var vid = b.getAttribute('data-vid');
        if (vid) return Promise.resolve(Number(vid));
        var h = b.getAttribute('data-handle');
        if (!h) return Promise.resolve(0);
        return fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            if (!p || !p.variants) return 0;
            for (var i = 0; i < p.variants.length; i++) {
              if (p.variants[i].available) return p.variants[i].id;
            }
            return 0;
          })
          .catch(function () { return 0; });
      });

      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      Promise.all(resolve).then(function (ids) {
      var items = ids.filter(Boolean).map(function (id) { return { id: id, quantity: 1 }; });
      if (!items.length) throw new Error('Not added');
      return fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: items })
      });
      }).then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, json: j }; })
                       .catch(function () { return { ok: r.ok, json: {} }; });
      }).then(function (res) {
        if (!res.ok) throw new Error((res.json && (res.json.description || res.json.message)) || 'Could not add');
        btn.textContent = 'Added ' + boxes.length;
        boxes.forEach(function (b) { b.checked = false; });
        /* The header count is owned by the section, which does not expose its
           updater, so say what happened and let anything listening refresh. */
        try { document.dispatchEvent(new CustomEvent('ll:cart:updated', { detail: { added: items.length } })); } catch (e) {}
        setTimeout(sync, 1600);
      }).catch(function (err) {
        btn.disabled = false;
        btn.textContent = (err && err.message) ? 'Not added' : 'Not added';
        setTimeout(sync, 2200);
      });
    });

    sync();
  }());

  /* WHERE THE SET DATA ALREADY WON, STAND DOWN.

     On a collection carrying custom.card_list the page has arrived complete
     and correct: every card in the set, named, with the ones this shop has
     never listed shown as such. Rebuilding that from the index would replace
     real names with names guessed from handles, and a 120 card set with the 84
     the printed numbers happen to describe.

     A FLAG, NOT AN EARLY RETURN. Returning here skipped the rest of this file,
     which is where the money formatter, the hover handlers and the paint queue
     are set up: the checklist rendered perfectly and then nothing in it worked,
     including the selection bar, which counted a tick and then threw before it
     could show itself. Only the rebuild is skipped now. */
  var SET_SOURCED = root.getAttribute('data-source') === 'set';

  if (!SET_SOURCED) getJson(url('ll-collection-map.json')).then(function (map) {
    var entry = map && map.collections && map.collections[handle];
    if (!entry) return null;
    mapEntry = entry;
    mapAll = map;

    var shards = (entry.shards && entry.shards[0] === '*')
      ? (map.shards || []) : (entry.shards || []);
    if (!shards.length) return null;

    var members = entry.members
      ? getJson(url('ll-members-' + handle + '.json'))
      : Promise.resolve(null);

    return Promise.all([
      members,
      Promise.all(shards.map(function (g) { return getJson(url('ll-index-' + g + '.json')); }))
    ]).then(function (both) {
      var mem = both[0], loaded = both[1].filter(Boolean);
      if (!loaded.length) return null;

      /* Which handles are in this collection, and what the index knows about
         each: stock, and the set it is filed under. */
      var want = null;
      if (mem && mem.handles) {
        want = Object.create(null);
        for (var i = 0; i < mem.handles.length; i++) want[mem.handles[i]] = 1;
      }

      var rows = [];
      loaded.forEach(function (shard) {
        var names = (shard.dict && shard.dict.set_name) || [];
        var facetCode = -1;
        if (!want && entry.facet === 'set_name' && entry.value) {
          facetCode = names.indexOf(entry.value);
          if (facetCode === -1) return;
        }
        shard.products.forEach(function (r) {
          if (want) { if (!want[r[0]]) return; }
          else if (facetCode > -1) { if (r[F_SET] !== facetCode) return; }
          else return;
          rows.push({
            handle: r[0],
            inStock: !!(r[F_FLAGS] & IN_STOCK),
            price: r[F_PRICE] || 0,
            set: (typeof r[F_SET] === 'number' && names[r[F_SET]]) || ''
          });
        });
      });
      if (!rows.length) return null;

      /* Group by printed denominator, which is the set, and record every
         PRINTING of each number rather than just whether the number is held.

         A master set is not the numbers 1 to 217. It is every printing of
         them: the base card, its reverse holo, the holo, and whatever secret
         rares sit above the printed size. A checklist that collapses those
         into one cell tells a master set collector almost nothing, because the
         cell is already filled by a card they are not chasing.

         The printing is in the handle, the same place the number is:

           erikas-oddish-ascended-heroes-energy-reverse-holo-001-217
           pecharunt-ascended-heroes-holo-143-217
           wailord-ex-pitch-black-016-084                     (base) */
      var sets = Object.create(null);
      rows.forEach(function (row) {
        var card = parseCard(row.handle);
        if (!card || !card.num) return;       /* sealed, no card number */
        var den = card.den;
        if (den > 500) return;

        /* KEYED ON THE SET NAME, not the denominator.

           The denominator was only ever a proxy for the set, and it is one the
           code-numbered games do not have. The index carries the set as a
           facet on every product, which is the authoritative answer for all of
           them. Products with no set on file still fall back to grouping by
           denominator so a Pokemon shelf does not lose them. */
        var key = row.set || (den ? ('den:' + den) : null);
        if (!key) return;

        var s = sets[key] || (sets[key] = {
          den: 0, nums: {}, stock: {}, names: {}, items: [], byNum: {}, dens: {}
        });
        if (den) s.dens[den] = (s.dens[den] || 0) + 1;
        var num = card.num;
        var printing = printingOf(row.handle);
        s.nums[num] = 1;
        if (row.inStock) s.stock[num] = 1;
        if (row.set) s.names[row.set] = (s.names[row.set] || 0) + 1;
        var cell = s.byNum[num] || (s.byNum[num] = {});
        cell[printing] = (cell[printing] || 0) + 1;
        if (row.inStock) cell.buyable = 1;
        s.items.push({
          num: num, handle: row.handle, price: row.price,
          inStock: row.inStock, set: row.set, printing: printing
        });
      });

      /* THE SET SIZE, PRINTED WHERE THERE IS ONE AND INFERRED WHERE THERE IS
         NOT.

         A slash game states its size on every card, so the size is whatever
         most of them agree on. A code game states nothing, so the best that
         can be said is the highest number on the shelf, and the display says
         "est" rather than presenting a guess as a fact. */
      Object.keys(sets).forEach(function (k) {
        var s = sets[k];
        var best = 0, bestN = 0;
        for (var d in s.dens) if (s.dens[d] > bestN) { bestN = s.dens[d]; best = Number(d); }
        var held = Object.keys(s.nums).map(Number);
        if (best && bestN >= s.items.length * 0.5) {
          s.den = best;
          s.estimated = false;
        } else {
          s.den = held.length ? Math.max.apply(null, held) : 0;
          s.estimated = true;
        }
      });

      var out = Object.keys(sets).map(function (k) { return sets[k]; })
        .filter(function (s) { return s.den > 0 && Object.keys(s.nums).length >= MIN_SET; });

      out.forEach(function (s) {
        var held = Object.keys(s.nums).map(Number);
        s.base = held.filter(function (n) { return n <= s.den; });
        s.above = held.filter(function (n) { return n > s.den; }).sort(function (a, b) { return a - b; });
        s.inStock = Object.keys(s.stock).length;

        /* The master set breakdown. Reverse holos are counted against the
           printed size because a set that reverses at all reverses nearly
           every base card, so 88 of 217 is a meaningful fraction. Secret rares
           have no knowable target, so they are reported as a count and never
           as a percentage of something invented. */
        /* EVERY GAME HAS VARIANTS; NOT EVERY GAME CALLS THEM REVERSE HOLOS.

           Counting reverses alone read 4,616 on Pokemon and a flat zero on One
           Piece, whose parallel printings are foils. A stat that is structurally
           zero for a whole game is worse than no stat. So this counts any card
           held in more than its plain printing, which is the axis a master set
           collector is actually working along whatever the game calls it. */
        s.reverse = [];
        s.printings = s.items.length;
        for (var n in s.byNum) {
          if (Number(n) > s.den) continue;
          var c = s.byNum[n];
          if (c.reverse || c.foil || c.holo || c.promo) s.reverse.push(Number(n));
        }

        var best = '', bestN = 0;
        for (var nm in s.names) if (s.names[nm] > bestN) { bestN = s.names[nm]; best = nm; }
        s.label = best ? titleCase(best) : ('Set of ' + s.den);
        s.setValue = best;
      });

      /* NOTHING INSIDE THE PRINTED SET, NOTHING TO SHOW.

         A set whose only stock is numbered ABOVE its printed size renders an
         empty grid and a line reading "Brilliant Stars 0/1", which says we
         stock none of a set of one and is true but useless. It happens where
         the only card held is a secret rare, or where a stray denominator has
         collected a few promos.

         The count line above still measures the sets that ARE shown, so
         hiding these does not move the headline. The moment one base card
         arrives the set reappears on its own, because this is computed from
         the index on every load rather than configured anywhere. */
      out = out.filter(function (s) { return s.base.length > 0; });
      if (!out.length) return null;

      out.sort(function (a, b) { return b.base.length - a.base.length; });
      return out;
    });
  }).then(function (sets) {
    if (!sets || !sets.length) return;
    render(sets);
  }).catch(function () { /* the page keeps what Liquid rendered */ });

  /* 6694/9315 is nine characters in a column 58px wide, so the collection wide
     strip ran out of room and clipped its last stat. Thousands are abbreviated
     above four figures, where the exact digit stopped being the point. */
  function shortNum(n) {
    if (n < 10000) return String(n);
    var k = n / 1000;
    return (k >= 100 ? Math.round(k) : k.toFixed(1).replace(/\.0$/, '')) + 'k';
  }

  function masterStat(label, n, of) {
    var w = el('span', 'llcl__stat');
    w.appendChild(el('b', null, of ? (shortNum(n) + '/' + shortNum(of)) : shortNum(n)));
    w.appendChild(el('span', null, label));
    w.title = of ? (n.toLocaleString() + ' of ' + of.toLocaleString() + ' ' + label)
                 : (n.toLocaleString() + ' ' + label);
    return w;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* ---- naming a card the index cannot name --------------------------------
     The index carries no titles, so a row it alone knows about has to take its
     name from the handle. The handle is the slugified title, so the pieces are
     all there: strip the trailing number pair, strip the set slug, and what is
     left is the card and its finish.

       galarian-obstagoon-ascended-heroes-reverse-holo-132-217
         -> Galarian Obstagoon      (reverse holo)

     This is a fallback and only a fallback. Any row Liquid already rendered
     keeps its real title, so on a set that fits inside 250 products nothing is
     derived at all; derivation only fills the tail of the big collections that
     could never be reached before. */

  var FINISH = {
    holo: 1, reverse: 1, foil: 1, promo: 1, alternate: 1,
    prerelease: 1, staff: 1, jumbo: 1, cosmos: 1, poke: 1, ball: 1,
    /* One Piece and Digimon name their parallels differently again. */
    art: 1, parallel: 1, manga: 1
  };
  var SMALL = { the: 1, of: 1, and: 1, a: 1, in: 1 };

  /* Game slugs that sit in front of a card's own name and say nothing about
     the card. Stripped only from the FRONT, so a card actually called Pokemon
     something keeps it. */
  var GAME_PREFIX = /^(one-piece|pokemon|digimon|disney-lorcana|lorcana|magic-the-gathering|mtg|yu-gi-oh)-/;

  function nameFromHandle(handle, setSlug) {
    /* Strip whichever numbering scheme this handle uses. Only the slash form
       was handled, so a One Piece row came out as "Izo Op16 002" with its set
       code and number still sitting in the name. */
    var t = handle;
    if (NUM.test(t)) t = t.replace(NUM, '');
    else if (CODE.test(t)) t = t.replace(CODE, '');
    t = t.replace(/-+$/, '');
    t = t.replace(GAME_PREFIX, '');
    if (setSlug) t = t.replace(new RegExp('-?' + setSlug + '-?', 'g'), '-');
    var parts = t.split('-').filter(Boolean);

    var tail = [];
    while (parts.length > 1 && FINISH[parts[parts.length - 1]]) tail.unshift(parts.pop());

    function cap(w, i) {
      if (w === 'ex' || w === 'gx' || w === 'vmax' || w === 'vstar') return w.toUpperCase();
      if (i > 0 && SMALL[w]) return w;
      return w.charAt(0).toUpperCase() + w.slice(1);
    }
    return {
      name: parts.map(cap).join(' ') || handle,
      variant: tail.join(' ')
    };
  }

  var MONEY;
  try {
    var _c = document.documentElement.getAttribute('data-currency') || 'GBP';
    var _nf = new Intl.NumberFormat('en-GB', { style: 'currency', currency: _c });
    MONEY = function (p) { return _nf.format(p / 100); };
  } catch (e) {
    MONEY = function (p) { return '£' + (p / 100).toFixed(2); };
  }

  function buildRow(item, setSlug) {
    var li = el('li', 'llcl__row' + (item.inStock ? ' llcl__row--in' : ''));
    li.id = 'llcl-card-' + item.num;
    li.setAttribute('data-num', String(item.num));
    li.setAttribute('data-handle', item.handle);

    if (item.inStock) {
      /* A box keyed by HANDLE rather than variant id.

         The index carries no variant ids, and fetching one per row to fill a
         list nobody may open would be a thousand requests for nothing. It is
         not needed at tick time either: the id is only wanted at the moment
         Add is pressed, and by then the selection is a handful of rows. So the
         box records which product it is and the ids are resolved on add.

         Without this, every row on a collection bigger than 250 products had
         neither a checkbox nor any other in stock marker, because the checkbox
         WAS the marker. */
      var box = document.createElement('input');
      box.type = 'checkbox';
      box.className = 'llcl__pick';
      box.setAttribute('data-handle', item.handle);
      box.setAttribute('aria-label', 'Select this card to add to cart');
      li.appendChild(box);
    } else {
      var gap = el('span', 'llcl__pick-gap');
      gap.setAttribute('aria-hidden', 'true');
      li.appendChild(gap);
    }

    var num = el('span', 'llcl__num', String(item.num));
    num.appendChild(el('span', 'llcl__den', '/' + item.den));
    li.appendChild(num);
    li.appendChild(thumbSlot(item.handle));

    var parsed = nameFromHandle(item.handle, setSlug);
    var a = el('a', 'llcl__name', parsed.name);
    a.href = '/products/' + item.handle;
    a.setAttribute('data-peek', item.handle);
    if (parsed.variant) a.appendChild(el('span', 'llcl__var', parsed.variant));
    li.appendChild(a);

    li.appendChild(el('span', 'llcl__price', item.price > 0 ? MONEY(item.price) : 'Price TBC'));
    li.appendChild(el('span', 'llcl__state', item.inStock ? 'In stock' : 'Sold out'));
    return li;
  }


  /* ---- rendering, and why almost none of it happens up front ---------------

     The first version built every grid cell and every priced row the moment
     the index came back. On a set page that is fine. On /collections/pokemon
     it was 72 sets, 9,318 number cells and 11,518 priced rows: 109,715 DOM
     nodes, about four fifths of them ours, and the page locked up hard enough
     that a one line script could not be evaluated in it.

     None of that work was needed on load. A shopper opens one set, maybe two.
     So a set is a summary line until it is opened, and its grid and its priced
     list are built the first time it is. A single set collection still shows
     its grid immediately, because there the grid IS the content and there is
     only one of it. */

  function render(sets) {
    var body = root.querySelector('.llcl__body');
    var sub = root.querySelector('.llcl__sub');
    var meter = root.querySelector('.llcl__meter i');
    var head = root.querySelector('.llcl__h');
    var tpl = root.querySelector('.llcl__disc');
    if (!body || !tpl) return;

    var totalHeld = 0, totalSize = 0, totalStock = 0;
    sets.forEach(function (s) {
      totalHeld += s.base.length; totalSize += s.den; totalStock += s.inStock;
    });
    var pct = totalSize ? Math.round(totalHeld * 100 / totalSize) : 0;
    var multi = sets.length > 1;

    if (head && multi) head.textContent = head.textContent.replace(/card list$/, 'card lists');

    var totalRev = 0, totalSecret = 0, totalPrint = 0;
    sets.forEach(function (s) {
      totalRev += s.reverse.length; totalSecret += s.above.length; totalPrint += s.printings;
    });

    if (sub) {
      /* THE SAME NUMBER THREE TIMES.

         This line read "Base set 77 of 84 (92%)" directly above a tile reading
         77/84 BASE and a bar drawn at 92%. Three renderings of one fact, and
         the line was the least scannable of them. The tiles keep the counts;
         this keeps only what they do not say. */
      sub.textContent = '';
      var anyEst = false;
      sets.forEach(function (x) { if (x.estimated) anyEst = true; });
      sub.appendChild(el('b', null, pct + '% complete'));
      if (anyEst) {
        var e = el('i', 'llcl__est', 'est');
        e.title = 'Some sets here print no set size, so it is estimated from the highest number stocked.';
        sub.appendChild(e);
      }
      sub.appendChild(document.createTextNode(
        (multi ? ' across ' + sets.length + ' sets' : '') +
        ' · ' + totalStock + ' buyable · ' + (totalSize - totalHeld) + ' to find'
      ));
    }
    if (meter) meter.style.width = pct + '%';

    /* The master set line: the three things a completionist counts, each with
       its own honest denominator. Base has a printed size. Reverse holos are
       measured against it because a set that reverses at all reverses nearly
       every card. Secret rares have no knowable target, so they are a count. */
    var head2 = root.querySelector('.llcl__master');
    if (!head2) {
      head2 = el('div', 'llcl__master');
      var headBox = root.querySelector('.llcl__head');
      if (headBox) headBox.appendChild(head2);
    }
    head2.textContent = '';
    head2.appendChild(masterStat('Base', totalHeld, totalSize));
    head2.appendChild(masterStat('Variant', totalRev, totalSize));
    head2.appendChild(masterStat('Secret', totalSecret, null));
    head2.appendChild(masterStat('Prints', totalPrint, null));

    /* Rows Liquid rendered are harvested before anything is torn down: they
       carry the real titles and the working checkboxes, and neither can be
       rebuilt from the index. */
    var existing = Object.create(null);
    [].slice.call(root.querySelectorAll('.llcl__row[data-handle]')).forEach(function (li) {
      existing[li.getAttribute('data-handle')] = li;
    });

    var old = body.querySelectorAll('.llcl__grid, .llcl__extras, .llcl__setname');
    for (var i = 0; i < old.length; i++) old[i].remove();

    sets.forEach(function (s) {
      var setSlug = '', bestN = 0;
      for (var nm in s.names) if (s.names[nm] > bestN) { bestN = s.names[nm]; setSlug = nm; }
      s.slug = setSlug;
      s.multi = multi;

      if (!multi) {
        body.insertBefore(buildGrid(s), tpl);
        body.insertBefore(buildKey(s), tpl);
        if (s.above.length) body.insertBefore(buildExtras(s), tpl);
        lazyList(tpl, s, existing);
        return;
      }

      /* A set is a line until someone wants it. 72 collapsed summaries cost
         a few hundred nodes; 72 open ones cost ninety thousand. */
      /* THREE THIN LINES, NOT A CARD.

         Each set used to be a wrapped title, an inline count and three chip
         pills stacked underneath: about 70px, and seventy of them in a list
         nobody can scan. The same facts fit in three lines that are each one
         line tall. The name gets the width and truncates rather than wrapping,
         the count sits hard right where the eye can run down it, and the
         counts a base percentage hides are plain text rather than pills. */
      var d = el('details', 'llcl__set');
      var sm = el('summary', 'llcl__set-s');

      var top = el('span', 'llcl__set-top');
      top.appendChild(el('span', 'llcl__setname-n', s.label));
      var c = el('span', 'llcl__setname-c', s.base.length + '/' + s.den);
      if (s.estimated) {
        /* Says out loud that this denominator is the highest number on the
           shelf rather than a printed set size, because One Piece and Digimon
           print no size and a bare 84/117 would read as though they did. */
        c.appendChild(el('i', 'llcl__est', 'est'));
        c.title = 'Set size not printed on these cards. Estimated from the highest number stocked.';
      }
      top.appendChild(c);
      sm.appendChild(top);

      var bar = el('span', 'llcl__bar');
      var fill = el('i');
      fill.style.width = Math.round(s.base.length * 100 / s.den) + '%';
      bar.appendChild(fill);
      var rev = el('b');
      rev.style.width = Math.round(s.reverse.length * 100 / s.den) + '%';
      bar.appendChild(rev);
      sm.appendChild(bar);

      var meta = el('span', 'llcl__meta-line');
      var bits = [];
      if (s.reverse.length) bits.push(s.reverse.length + ' variant');
      if (s.above.length) bits.push(s.above.length + ' secret');
      bits.push(s.printings + ' printings');
      meta.appendChild(el('span', 'llcl__meta-txt', bits.join(' · ')));
      /* The set's own filter value (the index's set_name), so the section can
         narrow the grid to exactly this set. A button inside a summary would
         also toggle the details, so its click is stopped where it is handled. */
      if (s.setValue) {
        d.setAttribute('data-set', s.setValue);
        var go = el('button', 'llcl__go');
        go.type = 'button';
        go.setAttribute('data-llcl-go', s.setValue);
        go.setAttribute('aria-label', 'Show ' + s.label + ' cards in the grid');
        go.innerHTML = '<span>Show cards</span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h13M13 6l6 6-6 6"/></svg>';
        meta.appendChild(go);
      }
      sm.appendChild(meta);
      d.appendChild(sm);

      var slot = el('div', 'llcl__set-body');
      d.appendChild(slot);
      body.insertBefore(d, tpl);

      var built = false;
      d.addEventListener('toggle', function () {
        if (!d.open || built) return;
        built = true;
        slot.appendChild(buildGrid(s));
        slot.appendChild(buildKey(s));
        if (s.above.length) slot.appendChild(buildExtras(s));
        var disc = tpl.cloneNode(true);
        slot.appendChild(disc);
        lazyList(disc, s, existing);
      });
    });

    if (multi) tpl.remove();
    root.setAttribute('data-llcl-complete', '1');
  }

  function buildGrid(s) {
    var ol = el('ol', 'llcl__grid');
    ol.setAttribute('aria-label', 'Card numbers in ' + s.label);
    var have = Object.create(null);
    s.base.forEach(function (v) { have[v] = 1; });

    /* One handle per number, so a cell can show the card it stands for. An in
       stock printing wins, because that is the one a shopper can act on. */
    var handleFor = Object.create(null);
    s.items.forEach(function (it) {
      if (!handleFor[it.num] || (it.inStock && !handleFor[it.num].inStock)) handleFor[it.num] = it;
    });

    for (var i = 1; i <= s.den; i++) {
      var cell = s.byNum[i];
      var cls = 'llcl__n';
      if (have[i]) {
        cls += ' llcl__n--have';
        /* The corner marker is the master set part: a filled cell says we have
           the card, the marker says we also have its reverse holo. Without it
           the grid looks finished to someone who is only missing reverses. */
        if (cell && (cell.reverse || cell.foil || cell.holo || cell.promo)) cls += ' llcl__n--rev';
        if (cell && !cell.buyable) cls += ' llcl__n--gone';
      }
      var li = el('li', cls);
      if (have[i]) {
        var a = el('a', null, String(i));
        a.href = '#' + rowId(s, i);
        if (handleFor[i]) a.setAttribute('data-peek', handleFor[i].handle);
        a.title = i + ' — ' + Object.keys(cell || {}).filter(function (k) { return k !== 'buyable'; }).join(', ');
        li.appendChild(a);
      } else {
        li.textContent = String(i);
        li.setAttribute('aria-label', 'Card ' + i + ', not in stock');
      }
      ol.appendChild(li);
    }
    return ol;
  }

  /* Secret rares were a run of loose numbers after a label, which is the one
     part of a checklist a collector reads most carefully and the part that
     looked least like the rest of it. Same cells as the grid above, so the
     eye treats them as what they are: more of the set, numbered past its end. */
  function buildExtras(s) {
    var wrap = el('div', 'llcl__secret');
    var head = el('p', 'llcl__secret-h');
    head.appendChild(el('span', null, 'Secret rares'));
    head.appendChild(el('b', null, String(s.above.length)));
    wrap.appendChild(head);

    var ol = el('ol', 'llcl__grid llcl__grid--secret');
    ol.setAttribute('aria-label', 'Cards numbered above ' + s.den + ' in ' + s.label);
    s.above.forEach(function (n) {
      var cell = s.byNum[n] || {};
      var cls = 'llcl__n llcl__n--have';
      if (cell.reverse || cell.foil || cell.holo || cell.promo) cls += ' llcl__n--rev';
      if (!cell.buyable) cls += ' llcl__n--gone';
      var li = el('li', cls);
      var a = el('a', null, String(n));
      a.href = '#' + rowId(s, n);
      var pick = null;
      for (var k = 0; k < s.items.length; k++) {
        if (s.items[k].num === n && (!pick || (s.items[k].inStock && !pick.inStock))) pick = s.items[k];
      }
      if (pick) a.setAttribute('data-peek', pick.handle);
      li.appendChild(a);
      ol.appendChild(li);
    });
    wrap.appendChild(ol);
    return wrap;
  }

  /* Card numbers repeat across sets, so a bare number stops being unique the
     moment a second set is on the page. */
  /* Three states worth a word each. Without this the corner notch is a smudge
     and a hollow cell reads as a rendering fault rather than as sold out. */
  function buildKey(s) {
    var k = el('div', 'llcl__key');
    function item(cls, text) {
      var i = el('span', 'llcl__key-i');
      i.appendChild(el('span', 'llcl__n ' + cls));
      i.appendChild(el('span', null, text));
      return i;
    }
    k.appendChild(item('llcl__n--have', 'in stock'));
    if (s.reverse.length) k.appendChild(item('llcl__n--have llcl__n--rev', 'variant too'));
    k.appendChild(item('llcl__n--have llcl__n--gone', 'sold out'));
    k.appendChild(item('', 'not stocked'));
    return k;
  }

  function rowId(s, num) {
    return s.multi ? ('llcl-card-' + s.den + '-' + num) : ('llcl-card-' + num);
  }

  /* The priced list is the expensive half and it lives behind a disclosure most
     visitors never open, so it is not built until they do. */
  function lazyList(disc, s, existing) {
    ensureThumbIO();
    /* Kicked off before a single row exists, so the map is already on its way
       by the time the first thumbnail scrolls into view. */
    bulkPrefetch();
    var ul = disc.querySelector('ul');
    if (!ul) return;

    /* Emptied here rather than in build(), because a set's disclosure is a
       clone of the one Liquid rendered and therefore arrives holding a copy of
       all 217 server rows. Left until the disclosure was opened, every closed
       set carried a stale duplicate of them, ids and all. */
    ul.innerHTML = '';

    s.items.sort(function (a, b) { return a.num - b.num; });
    var seen = Object.create(null), unique = [];
    s.items.forEach(function (item) {
      if (seen[item.handle]) return;
      seen[item.handle] = 1;
      item.den = s.den;
      unique.push(item);
    });

    /* Started as soon as the set's list is prepared, so the pictures are on
       their way before the first row scrolls into view. */
    var slugEntry = mapAll && mapAll.collections && mapAll.collections[s.slug];
    ul.__llclBulk = s.multi && slugEntry
      ? bulkFor(s.slug, slugEntry.count)
      : bulkPrefetch();

    /* COLLECTING TOOLS.

       The list answers "how much" one row at a time, which is fine for buying
       a card and useless for filling a set. These two do the gathering: one
       tick takes everything in the set that can actually be bought, and the
       filter clears the sold out rows out of the way so what is left is a
       shopping list rather than a catalogue. */
    var tools = el('div', 'llcl__tools');

    var all = el('button', 'llcl__tool', 'Select all buyable');
    all.type = 'button';
    all.addEventListener('click', function () {
      var boxes = ul.querySelectorAll('input.llcl__pick');
      var anyOff = false;
      for (var i = 0; i < boxes.length; i++) if (!boxes[i].checked) { anyOff = true; break; }
      for (var j = 0; j < boxes.length; j++) boxes[j].checked = anyOff;
      all.textContent = anyOff ? 'Clear selection' : 'Select all buyable';
      /* Dispatched from a BOX, not from the root. The bulk bar listens for a
         change whose target carries the checkbox class, so an event raised on
         the container matched nothing: ninety one rows were ticked on screen
         while the bar still read zero selected and stayed hidden. */
      if (boxes[0]) boxes[0].dispatchEvent(new Event('change', { bubbles: true }));
    });
    tools.appendChild(all);

    var only = el('label', 'llcl__tool llcl__tool--check');
    var onlyBox = document.createElement('input');
    onlyBox.type = 'checkbox';
    onlyBox.addEventListener('change', function () {
      ul.classList.toggle('is-buyable-only', onlyBox.checked);
    });
    only.appendChild(onlyBox);
    only.appendChild(el('span', null, 'In stock only'));
    tools.appendChild(only);

    ul.parentNode.insertBefore(tools, ul);

    var label = disc.querySelector('.llcl__disc-s span');
    if (label) {
      label.textContent = s.multi
        ? ('Show the ' + unique.length + ' ' + s.label + ' cards with prices')
        : ('Show all ' + unique.length + ' cards with prices');
    }

    /* BUILT IN SLICES.

       377 rows is a few thousand elements, and building them in one pass is a
       single blocking task at exactly the moment someone taps to open a set,
       which is the worst time to have one. The first slice fills the panel
       immediately and the rest arrive a frame at a time, so the list is usable
       before it is finished. */
    var built = false;
    function build() {
      if (built) return;
      built = true;
      var i = 0;

      function slice(budget) {
        var frag = document.createDocumentFragment();
        var end = Math.min(i + budget, unique.length);
        for (; i < end; i++) {
          var item = unique[i];
          var li = existing[item.handle] || buildRow(item, s.slug);
          li.id = rowId(s, item.num);
          /* A reused row never passes through buildRow, so it has to be told
             which product it is before the shared hover handler acts on it. */
          var nameEl = li.querySelector('.llcl__name');
          if (nameEl && !nameEl.hasAttribute('data-peek')) {
            nameEl.setAttribute('data-peek', item.handle);
          }
          if (!li.querySelector('.llcl__thumb')) {
            li.insertBefore(thumbSlot(item.handle), nameEl);
          }
          frag.appendChild(li);
        }
        ul.appendChild(frag);
        observeRows(ul);
        if (i < unique.length) requestAnimationFrame(function () { slice(60); });
      }

      slice(40);
    }

    disc.addEventListener('toggle', function () { if (disc.open) build(); });
    if (disc.open) build();
    disc.__llclBuild = build;
  }

  /* A grid cell links to a row inside a disclosure that may not be open, and
     on a multi set page may not even be built yet. Without this a filled number
     scrolled nowhere at all. */
  root.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.llcl__grid a[href^="#llcl-card-"]');
    if (!a) return;
    var scope = a.closest('.llcl__set-body') || root;
    var disc = scope.querySelector('.llcl__disc');
    if (disc) {
      if (disc.__llclBuild) disc.__llclBuild();
      disc.open = true;
    }
    e.preventDefault();

    /* The rows are built a slice at a time, so the one this cell points at
       very likely does not exist yet on the click that opened the list: the
       first pick highlighted nothing while every later pick worked. Wait for
       it rather than guessing how many frames the build will take. */
    whenRow(a.getAttribute('href').slice(1), function (target) {
      landOn(target);
    });
  });

  function whenRow(id, cb, tries) {
    var target = document.getElementById(id);
    if (target) { cb(target); return; }
    tries = (tries || 0) + 1;
    if (tries > 40) return;               /* ~40 frames, then give up quietly */
    requestAnimationFrame(function () { whenRow(id, cb, tries); });
  }

  function landOn(target) {

    /* EVERY PRINTING OF THAT NUMBER, not just the first row.

       Opening the list at the right place still left you hunting: the rows all
       look alike and a master set number often has three of them, base, holo
       and reverse. Highlighting the number's whole run answers the question
       the cell was asked, which is "what have you got for card 47", and the
       previous pick is cleared so only one answer is on screen at a time. */
    var num = target.getAttribute('data-num');
    var list = target.closest('ul');
    var was = root.querySelectorAll('.llcl__row.is-target');
    for (var i = 0; i < was.length; i++) was[i].classList.remove('is-target');

    var run = list ? list.querySelectorAll('.llcl__row[data-num="' + num + '"]') : [target];
    for (var j = 0; j < run.length; j++) run[j].classList.add('is-target');

    /* A row hidden by the in stock filter cannot be scrolled to, and silently
       going nowhere reads as a broken link. */
    if (getComputedStyle(target).display === 'none' && list) {
      list.classList.remove('is-buyable-only');
      var box = list.parentNode.querySelector('.llcl__tool--check input');
      if (box) box.checked = false;
    }
    target.scrollIntoView({ block: 'center' });
  }
  /* ---- hovering a number shows the card ------------------------------------
     The grid answers "do they have it" and the list answers "how much", but
     neither shows the card, and on a set page the picture is most of what a
     collector is checking. The index carries no images, so the product is
     fetched on hover and remembered: a shopper skims a handful of numbers, not
     two hundred, so this stays a few requests rather than a preload. */

  var peekEl = null, peekCache = Object.create(null), peekFor = null;
  var mapEntry = null, mapAll = null;

  /* ---- loading the pictures without stalling the scroll --------------------

     THREE THINGS WERE WRONG.

     The observer was rooted on the VIEWPORT while the rows live inside
     .llcl__body, which is the thing that actually scrolls. Its 200px margin
     was therefore measured against the window and meant nothing to the panel,
     so rows arrived in the wrong batches.

     Every row that entered view fired its own request immediately. Flicking
     down a 322 row list put hundreds of fetches in flight at once, and the
     tail of that queue was still resolving long after the shopper had stopped,
     which is the lag: not the images, the stampede.

     And each product needed its own request in the first place, when the
     storefront will hand over a whole collection, images included, in one.

     So: one bulk request where it can cover the page, an observer rooted on
     the real scroller, and a queue that never has more than a few requests
     open and drops anything that scrolled back out of view before its turn. */

  var thumbIO = null;
  var bulkCache = Object.create(null);   /* slug -> promise of {handle: image} */
  var queue = [], inFlight = 0;
  var MAX_INFLIGHT = 5;

  /* ONE REQUEST PER SET, NOT ONE PER CARD.

     A collection's products.json hands over up to 250 products WITH their
     images. On a set page that is the whole shelf in a single request and no
     card ever needs its own.

     A parent collection cannot use it: POKEMON is 12,985 products, 52 pages,
     and its first page would rarely be the rows on screen. That is why the big
     collections were still making a request per visible row, and why they were
     the ones that stuttered.

     But the rows being LOOKED at always belong to one set, and 139 of the 159
     sets in the index are collections in their own right. So when a set is
     opened its own collection is fetched instead: Fusion Strike is one request
     rather than forty. The 20 sets with no collection of their own, and any
     set larger than two pages, fall back to the per row queue.

     THE PROMISE is cached, not the result. Caching only the result meant every
     caller that arrived while a request was open was told there was no map and
     went off to fetch its own product. */
  function bulkFor(slug, count) {
    if (!slug) return Promise.resolve(null);
    if (bulkCache[slug]) return bulkCache[slug];
    /* ONE PAGE, OR NONE.

       products.json returns whole product objects, variants and all, so a page
       of 250 is megabytes and JSON.parse of it is a single blocking task. Two
       pages for Ascended Heroes was a 426ms frame on its own: the bulk request
       had simply moved the stall from the network to the parser.

       One page is worth it because it covers a whole set page and removes
       every per row request there. Anything larger is left to the per row
       queue, which fetches a handful of small products once scrolling stops
       and never parses more than it is about to draw. */
    if (!(count > 0) || count > 250) {
      bulkCache[slug] = Promise.resolve(null);
      return bulkCache[slug];
    }
    bulkCache[slug] = fetch('/collections/' + slug + '/products.json?limit=250',
                            { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j.products) return null;
        var m = Object.create(null), any = false;
        j.products.forEach(function (pr) {
          var img = pr.images && pr.images[0] && pr.images[0].src;
          if (pr.handle && img) { m[pr.handle] = img; any = true; }
        });
        return any ? m : null;
      })
      .catch(function () { return null; });
    return bulkCache[slug];
  }

  /* The collection being viewed, which covers a set page in one go. */
  function bulkPrefetch() {
    return bulkFor(handle, mapEntry && mapEntry.count);
  }

  /* The set a row belongs to, which covers a set opened inside a big one. */
  function bulkForRow(b) {
    var ul = b.closest('ul');
    if (ul && ul.__llclBulk) return ul.__llclBulk;
    return bulkPrefetch();
  }

  /* PAINTING WAITS FOR THE SCROLL TO STOP.

     Fixing the requests made the rendering worse, which only showed up when
     measured. With one bulk response every picture is available instantly, so
     a scroll that used to attach 39 images attached 274, and the median frame
     went from 40ms to 73ms with a 203ms worst case. The stampede had moved
     from the network to the decoder, and batching a few per frame did not help
     because the problem was the total, not the burst.

     Nobody looks at a row they are flicking past. So a row entering view only
     REGISTERS its picture; nothing is attached until the container has been
     still for a moment, and then only for the rows actually on screen. A fast
     scroll through 377 rows now paints the dozen you land on instead of 274
     you never saw. */
  var pending = [], lastScroll = 0, paintTimer = null;
  /* How still the list has to be before pictures are drawn.

     A real fling fires scroll events continuously, so nothing is drawn while
     one is in progress whatever this is set to; the number governs how quickly
     pictures appear once you slow down. 130ms was cautious enough that a
     gentle scroll felt like it was withholding them. At 60ms they fill in
     almost as soon as you ease off, and a genuine flick is still skipped. */
  var QUIET_MS = 60, PER_PASS = 12;

  function paint(b, src) {
    if (!src || b.classList.contains('is-loaded') || b.__llclSrc) return;
    b.__llclSrc = src;
    pending.push(b);
    schedulePaint();
  }

  function schedulePaint() {
    if (paintTimer) return;
    paintTimer = setTimeout(runPaint, QUIET_MS);
  }

  function runPaint() {
    paintTimer = null;
    if (performance.now() - lastScroll < QUIET_MS) { schedulePaint(); return; }

    /* THE BOUNDS ARE READ ONCE.

       onScreen used to measure the scroller for every pending row, so a pass
       over 377 of them forced hundreds of layout reads and produced a 419ms
       frame: the check for cheap painting cost more than the painting. The
       container is measured once here and each row is compared against that. */
    var scroller = root.querySelector('.llcl__body');
    var top = 0, bottom = window.innerHeight;
    if (scroller) {
      var sr = scroller.getBoundingClientRect();
      top = sr.top; bottom = sr.bottom;
    }

    var next = [], done = 0;
    for (var i = 0; i < pending.length; i++) {
      var b = pending[i];
      if (b.classList.contains('is-loaded')) continue;
      if (done >= PER_PASS) { next.push(b); continue; }
      var r = b.getBoundingClientRect();
      var visible = (r.width || r.height) && r.bottom > top - 80 && r.top < bottom + 80;
      if (!visible) { next.push(b); continue; }
      done++;
      if (b.__llclSrc) { attach(b, b.__llclSrc); continue; }
      (function (btn) {
        loadProduct(btn.getAttribute('data-thumb')).then(function (pr) {
          if (pr) attach(btn, pr.featured_image || (pr.images && pr.images[0]));
        }).catch(function () {});
      }(b));
    }
    pending = next;
    /* Anything still waiting is either off screen or over this pass's budget,
       so come back for it rather than dropping it. */
    if (pending.length && done > 0) schedulePaint();
  }

  function noteScroll() { lastScroll = performance.now(); schedulePaint(); }

  function attach(b, src) {
    if (b.classList.contains('is-loaded')) return;
    var img = new Image();
    img.decoding = 'async';
    img.loading = 'lazy';
    img.alt = '';
    /* A fixed box in CSS already, so give the element the same intrinsic size
       and the row never reflows as pictures arrive. */
    img.width = 72; img.height = 72;
    img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=72';
    b.appendChild(img);
    b.classList.add('is-loaded');
  }

  /* Still worth loading? A row flicked past while its turn was queued is not,
     and skipping it is what keeps a fast scroll cheap. */
  function stillWanted(b) {
    if (!b.isConnected || b.classList.contains('is-loaded')) return false;
    var scroller = b.closest('.llcl__body');
    var r = b.getBoundingClientRect();
    /* A row under content-visibility: auto reports a zero size box while it is
       still skipped, and measuring one told this that every thumbnail had
       scrolled away: nothing loaded at all. The observer only queues what it
       has just seen intersect, so when there is nothing to measure, believe it
       rather than the rectangle. */
    if (r.width === 0 && r.height === 0) return true;
    var top = 0, bottom = window.innerHeight;
    if (scroller) {
      var sr = scroller.getBoundingClientRect();
      top = sr.top; bottom = sr.bottom;
    }
    return r.bottom > top - 400 && r.top < bottom + 400;
  }

  function pump() {
    while (inFlight < MAX_INFLIGHT && queue.length) {
      var b = queue.shift();
      if (!stillWanted(b)) continue;
      inFlight++;
      /* eslint-disable no-loop-func */
      (function (btn) {
        loadProduct(btn.getAttribute('data-thumb')).then(function (p) {
          if (p) paint(btn, p.featured_image || (p.images && p.images[0]));
        }).catch(function () {}).then(function () {
          inFlight--;
          pump();
        });
      }(b));
    }
  }

  function thumbSlot(handle) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'llcl__thumb';
    b.setAttribute('data-thumb', handle);
    b.setAttribute('aria-label', 'Show a picture of this card');
    return b;
  }

  /* The ROW is observed, not the thumbnail inside it.

     Rows carry content-visibility: auto so the browser can skip drawing the
     ones off screen, which took the median frame during a scroll from 36ms to
     23ms and the long frames from 20 to none. The catch is that a skipped row
     never reports its descendants, so observing the button meant no picture in
     a 322 row list ever loaded. The row is the element the browser is tracking,
     so that is the element to watch, and the button is found inside it once it
     is on screen. */
  function observeRows(ul) {
    if (!thumbIO) return;
    var rows = ul.querySelectorAll('.llcl__row');
    for (var i = 0; i < rows.length; i++) thumbIO.observe(rows[i]);
  }

  function ensureThumbIO(scope) {
    if (thumbIO || !window.IntersectionObserver) return;

    /* Rooted on the panel body where that is what scrolls, and on the window
       where the checklist has fallen back to a plain block. */
    var scroller = (scope || root).querySelector('.llcl__body');
    if (scroller) {
      var oy = getComputedStyle(scroller).overflowY;
      if (oy !== 'auto' && oy !== 'scroll') scroller = null;
    }

    if (scroller) scroller.addEventListener('scroll', noteScroll, { passive: true });
    window.addEventListener('scroll', noteScroll, { passive: true });

    thumbIO = new IntersectionObserver(function (entries) {
      var hits = [];
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        thumbIO.unobserve(en.target);
        var b = en.target.querySelector('.llcl__thumb');
        if (b && !b.classList.contains('is-loaded')) hits.push(b);
      });
      if (!hits.length) return;

      hits.forEach(function (b) {
        bulkForRow(b).then(function (map) {
          var src = map && map[b.getAttribute('data-thumb')];
          if (src) { paint(b, src); return; }
          /* No bulk map for this set, so the picture has to be fetched. That
             waits for the same quiet moment the painting does, so a flick
             through a set fetches nothing at all. */
          if (b.__llclSrc || b.__llclPending) return;
          b.__llclPending = 1;
          pending.push(b);
          schedulePaint();
        });
      });
    }, { root: scroller || null, rootMargin: '300px 0px' });
  }

  function loadProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (peekCache[handle]) return Promise.resolve(peekCache[handle]);
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) peekCache[handle] = p; return p; })
      .catch(function () { return null; });
  }

  /* Tapping a thumbnail opens it large. One overlay, reused, dismissed by a tap
     anywhere on it or by Escape. */
  var boxEl = null;

  function openBox(handle) {
    loadProduct(handle).then(function (p) {
      if (!p) return;
      if (!boxEl) {
        boxEl = el('div', 'llcl__box');
        boxEl.hidden = true;
        boxEl.addEventListener('click', closeBox);
        document.body.appendChild(boxEl);
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') closeBox();
        });
      }
      boxEl.innerHTML = '';
      var src = p.featured_image || (p.images && p.images[0]);
      if (src) {
        var img = new Image();
        img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=900';
        img.alt = p.title;
        boxEl.appendChild(img);
      }
      boxEl.appendChild(el('span', 'llcl__box-t', p.title));
      boxEl.hidden = false;
    });
  }

  function closeBox() { if (boxEl) boxEl.hidden = true; }

  root.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.llcl__thumb');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    openBox(b.getAttribute('data-thumb'));
  });



  function peekShow(a) {
    var handle = a.getAttribute('data-peek');
    if (!handle) return;
    peekFor = handle;

    if (!peekEl) {
      peekEl = el('div', 'llcl__peek');
      peekEl.hidden = true;
      document.body.appendChild(peekEl);
    }
    var r = a.getBoundingClientRect();
    /* Left of the rail, which is where the room is, and clamped so a cell near
       the bottom does not push the preview off the screen. */
    peekEl.style.top = Math.max(8, Math.min(r.top - 40, window.innerHeight - 260)) + 'px';
    /* Left of whatever was hovered, unless there is no room there, in which
       case it goes to the right of it: a row in a narrow drawer has the rail
       hard against the screen edge. */
    var want = r.left - 214;
    peekEl.style.left = (want < 8 ? Math.min(r.right + 12, window.innerWidth - 208) : want) + 'px';

    function paint(p) {
      if (peekFor !== handle || !p) return;
      peekEl.innerHTML = '';
      var src = p.featured_image || (p.images && p.images[0]);
      if (src) {
        var img = new Image();
        img.src = src.indexOf('?') > -1 ? src + '&width=360' : src + '?width=360';
        img.alt = '';
        peekEl.appendChild(img);
      }
      peekEl.appendChild(el('span', 'llcl__peek-t', p.title));
      peekEl.hidden = false;
    }

    if (peekCache[handle]) { paint(peekCache[handle]); return; }
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r2) { return r2.ok ? r2.json() : null; })
      .then(function (p) { if (p) { peekCache[handle] = p; paint(p); } })
      .catch(function () {});
  }

  function peekHide() { peekFor = null; if (peekEl) peekEl.hidden = true; }

  /* Gated on the POINTER, not on a hover media query.

     `(hover: hover)` looked like the right test and is not: it reports false on
     plenty of real desktops, and it reported false in the browser this was
     built in, which suppressed the preview on a machine with a mouse and no
     touchscreen at all. pointerType is the fact rather than an inference, so a
     mouse gets the preview and a finger never does. */
  function peekFromEvent(e, show) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var a = e.target.closest && e.target.closest('a[data-peek]');
    if (!a) return;
    if (show) peekShow(a); else peekHide();
  }

  root.addEventListener('pointerover', function (e) { peekFromEvent(e, true); });
  root.addEventListener('pointerout', function (e) { peekFromEvent(e, false); });

  /* Keyboard gets the same thing on focus, where there is no pointer at all. */
  root.addEventListener('focusin', function (e) {
    var a = e.target.closest && e.target.closest('a[data-peek]');
    if (a) peekShow(a);
  });
  root.addEventListener('focusout', peekHide);
  window.addEventListener('scroll', peekHide, { passive: true });
  /* The markup is already right; these are the parts markup cannot do. Placed
     last so every helper it leans on has been defined. */
  if (SET_SOURCED) {
    ensureThumbIO();
    var served = root.querySelector('[data-llcl-list]');
    if (served) {
      [].slice.call(served.querySelectorAll('.llcl__row[data-handle]')).forEach(function (li) {
        if (li.querySelector('.llcl__thumb')) return;
        var nameEl = li.querySelector('.llcl__name');
        if (nameEl) li.insertBefore(thumbSlot(li.getAttribute('data-handle')), nameEl);
      });
      observeRows(served);
    }
    root.setAttribute('data-llcl-complete', 'set');
  }
}());
